<template>
  <div class="login">
    <section class="section">
      <div class="columns">
        <div class="column is-12">
          <h1 class="title">
            Please Login
          </h1>
        </div>
      </div>

      <!-- Begin Login Form -->
      <div class="columns is-multiline">
        <div class="column is-12">
          <b-field label="Client" label-for="client">
            <b-select
              id="client"
              name="client"
              placeholder="Please select a client"
              v-model="selectedClient"
              required
            >
              <option
                v-for="(client, index) in clients"
                :key="index"
                :value="client.name"
              >
                {{ client.name }}</option
              >
            </b-select>
          </b-field>
        </div>
        <div class="column is-6">
          <b-field label="Username" label-for="username">
            <b-input
              id="username"
              name="username"
              type="text"
              placeholder="Enter your Username"
              v-model="username"
              required
              @keyup.enter.native="handleLogin"
            ></b-input>
          </b-field>
        </div>
        <div class="column is-6">
          <b-field label="Password" label-for="password">
            <b-input
              id="password"
              name="password"
              placeholder="Please enter your Password"
              type="password"
              v-model="password"
              required
              password-reveal
              @keyup.enter.native="handleLogin"
            ></b-input>
          </b-field>
        </div>
        <div class="column is-12">
          <b-button type="is-primary" native-type="submit" @click="handleLogin">
            Submit
          </b-button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'login',
  components: {},
  data() {
    return {
      username: null,
      password: null,
      selectedClient: null,
      clients: [
        { name: 'BALH' },
      ],
    };
  },
  methods: {
    handleLogin: function() {
      let username = this.username;
      let password = this.password;
      let selectedClient = this.selectedClient;

      this.$store
        .dispatch('login', { username, password, selectedClient })
        .then(() => {
          if (this.authStatus == 'error') {
            this.$router.push('/login');
          } else {
            this.$router.push(`/${this.$route.query.requested}`);
          }
        })
        .catch((err) => {
          // eslint-disable-next-line
          console.log(err);
        });
    },
    handleLogout: function() {
      this.$store
        .dispatch('logout')
        .then(() => {
          this.$router.push('/login');
        })
        // eslint-disable-next-line
        .catch((err) => console.log(err));
    },
  },
  computed: {
    ...mapGetters(['authStatus']),
  },
};
</script>

<style></style>
